import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router/index'
import App from './App.vue'

Vue.use(ElementUI, {
	input: {
		autocomplete: 'new-password', // 禁用自动填充
	},
})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  render: h => h(App),
}).$mount('#app')
